<template>
  <div id="system_users_list">
    <CardedTable
      :items="items"
      :headers="headers"
      :height="is_adding_admin ? 300 : 550"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn
          @click="on_disable_user(item)"
          x-small
          rounded
          outlined
          class="ml-2"
          color="warning"
          v-if="item.status == 'active' && is_adding_admin == false"
        >
          Disable Account
        </v-btn>
        <v-btn
          @click="on_activate_user(item)"
          x-small
          rounded
          outlined
          class="ml-2"
          color="success"
          v-if="item.status != 'active' && is_adding_admin == false"
        >
          Activate Account
        </v-btn>
        <v-btn
          @click="on_delete_user(item)"
          x-small
          rounded
          outlined
          class="ml-2"
          color="error"
          v-if="is_adding_admin == false"
        >
          Delete User
        </v-btn>
        <v-btn
          @click="on_select_user(item)"
          x-small
          rounded
          outlined
          class="ml-2"
          color="success"
          v-if="is_adding_admin == true"
        >
          select user
        </v-btn>
      </template>
    </CardedTable>
  </div>
</template>

<script>
import CardedTable from "../../../components/CardedTable";
import ServerClient from "../../../lib/ServerClient";
import Utils from "../../../lib/Utils";
export default {
  name: "AdminUsersList",
  components: {
    CardedTable,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => {
        return ServerClient.Login.get_logged_in_user();
      },
    },
    is_adding_admin: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      _user: null,
      items: [],
      headers: [
        {
          text: "ID",
          align: "start",
          sortable: true,
          value: "id",
          filterable: true,
        },
        {
          text: "User Name",
          align: "start",
          sortable: false,
          value: "email",
          filterable: true,
        },
        {
          text: "First Name",
          align: "start",
          sortable: false,
          value: "first_name",
          filterable: true,
        },
        {
          text: "Last Name",
          align: "start",
          sortable: true,
          value: "last_name",
          filterable: true,
        },
        {
          text: "Status",
          align: "center",
          sortable: true,
          value: "status",
          filterable: true,
        },
        { text: "", value: "actions", sortable: false, align: "end" },
      ],
    };
  },
  methods: {
    auto_fill_select_first_item() {
      //this method is used by the debugger round button
      if (this.items.length > 1) {
        this.$emit("on-auto-fill-selected-first-item", this.items[this.items.length -1]);
      } else {
        alert("No system Other System Users available to auto select apart from the super admin");
      }
    },
    load_items() {
      this.$emit("on-show-loader");
      ServerClient.Security.get_system_users(
        {},
        (res) => {
          this.$emit("on-hide-loader");
          
          this.items = res;
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log(
            "Errors while loading system users list",
            errors
          );
        }
      );
    },
    on_disable_user(item) {
        this.$router.push("/admin/users/list/disable/" + item.id);
    },
    on_activate_user(item) {
        this.$router.push("/admin/users/list/activate/" + item.id);
    },
    on_delete_user(item) {
        this.$router.push("/admin/users/list/delete/" + item.id);
    },
    on_select_user(item) {
      this.$emit('on-selected-system-user',item);
    },
  },
  mounted() {
    this._user = ServerClient.Login.get_logged_in_user();
    this.$emit("set-page-attributes", {
      title: "System Users",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Users",
          disabled: false,
          href: "/admin/users",
        },
        {
          text: "List",
          disabled: true,
          href: "/admin/users/list",
        },
      ],
    });
    this.load_items();
    if (this.is_adding_promotion == false) {
      var options = {
        offset: 50,
        duration: 1000,
        easing: "easeInOutCubic",
      };
      this.$vuetify.goTo("#system_users_list", options);
    }
  },
};
</script>